(function() {
    'use strict';

    angular
        .module('cloudApp')
        .constant('password_pattern', /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])/);
})();
